
import React from 'react';
import Header from './Header';
import ProgressSteps from './ProgressSteps';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import { useLocation } from 'react-router-dom';

export default function Layout({ children }) {
    const location = useLocation();
    const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    const onHelpRoute = location.pathname.startsWith('/help');
    const onWinnersRoute = location.pathname.startsWith('/winners-assets');
    const onKickoffRoute = location.pathname.startsWith('/kickoff/');

    // Hide header on public access screens and on help only when logged out.
    const hideHeader =
        location.pathname === '/' ||
        location.pathname.includes('/invite/') ||
        location.pathname.startsWith('/login') ||
        location.pathname.startsWith('/otp') ||
        location.pathname.startsWith('/forgotpassword') ||
        location.pathname.startsWith('/notqualified') ||
        onKickoffRoute ||
        onWinnersRoute ||
        (onHelpRoute && !token);

    // Progress stepper is only useful in the application workflow; keep it hidden on help pages.
    const hideProgressSteps = hideHeader || onHelpRoute || onWinnersRoute;
    return (
        // use full viewport height and flex layout so we can make the content area scroll independently
        <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column', bgcolor: 'background.default', overflow: 'hidden' }}>
            {!hideHeader && <Header />}
            {!hideProgressSteps && <ProgressSteps />}
            {/* scrolling region for page content; header + progress stay fixed above */}
            <Box sx={{ flex: 1, overflowY: 'auto' }}>
                <Container maxWidth="lg" sx={{ pt: 0, pb: { xs: 2, md: 4 } }}>
                    {children}
                </Container>
            </Box>
        </Box>
    );
}
